/**
 * Check if browser is IE 10
 * 
 * @return {Boolean}
 */
const isBrowserIE10 = () => navigator.userAgent.match('MSIE 10.0;')

export default isBrowserIE10
